import React from 'react';
import { Link } from 'react-router-dom';
import { PriceConvert } from '../../../../../UI/Price/Price';

export default function AttributeButton(props) {
  const attributeValues = props.attribute.values;
  const attrValues = props.getAttributeValues(attributeValues);

  let sortedVals = attrValues;

  let selectedAttributeName = props.selectedAttributeName;
  // let checkAvailVal = props.passedFunctions.parentState.currentAttributeState[props.attribute.name].selectedValue;
  let selectedValue = props.passedFunctions.parentState.currentAttributeState[props.attribute.name].selectedValue;

  if (selectedAttributeName == 'Swatch') {
    selectedAttributeName = 'Color';
  }

  if (attrValues.length === 1) {
    props.currentAttributeState[props.attribute.name].selectedValue = attrValues[0];
  }

  const additionalSizes =
    props.contentData.additionalSizes?.filter((currentSize) => currentSize.productURL !== '') ?? [];

  const isAvailable = (attrVal) => {
    if (props.availableValues.length > 0) {
      return props.availableValues.includes(attrVal);
    } else {
      return true;
    }
  };

  let isGiftCard = false;
  if (props.attribute.name === 'Amount') {
    isGiftCard = true;
  }

  const hasSizeChart = props.attribute.name == 'Size' && props.contentData.sizeChartName;
  const shouldShowSizeChart =
    hasSizeChart && ((props.passedAppFunctions.siteFormat == 'desktop' && props.isQuickview) || !props.isQuickview);
  const shouldShowAdditionalSize = additionalSizes.length > 0 && props.attribute.name === 'Size';
  const pricingObj = props.passedFunctions.parentState.pricingObj;
  const shouldShowPriceInButton =
    Object.keys(props.currentAttributeState).length === 1 && Object.keys(pricingObj).length > 1 && !isGiftCard;

  let fromQuickView = false;
  if ((props.availableValues.length === 0) & props.passedAppFunctions.fromQv) {
    fromQuickView = true;
  }

  return (
    <>
      <div className={`form-group ${props.attribute.hasError ? 'form-group-error' : ''} ${props.attribute.name}`}>
        <div className='productDisplay__div--labelWrapper'>
          <label className='label' htmlFor={props.attribute.name + '__' + props.contentData.partNumber}>
            {props.attribute.name}
          </label>
          {shouldShowSizeChart && (
            <button className='productDisplay__span--sizeChart' type='button' onClick={props.openSizeChart}>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 53.48 26.78' width='14'>
                <title>size chart</title>
                <g data-name='Layer 2'>
                  <g data-name='Layer 1'>
                    <path d='M0,0V26.78H53.48V0ZM51.48,24.78H2V2h9.14v8.07h2V2h12.6V15.12h2V2H40.33v8.07h2V2h9.15Z' />
                  </g>
                </g>
              </svg>
              Size Chart
              <span className='sr-only'>Opens a simulated dialog</span>
            </button>
          )}
        </div>

        <div
          className='attrSelect productDisplay__ul--flatSizeWrapper'
          id={props.attribute.name + '__' + props.contentData.partNumber}
          tabIndex='-1'
          aria-describedby={props.attribute.hasError && 'invalidComboContainer'}
          name={props.attribute.name}
        >
          {sortedVals.map((attrValue, index) => {
            let price = '';
            if (shouldShowPriceInButton) {
              price = Object.keys(pricingObj).find((price) => {
                return pricingObj[price]?.swatches?.find((swatch) => swatch.colorForSwatch === attrValue);
              });
            }
            return (
              <button
                type='button'
                key={props.attribute.name + index}
                onClick={props.changeAttributeState}
                className={`${isAvailable(attrValue) || fromQuickView ? 'available' : 'not-available'}${selectedValue == attrValue ? ' selected' : ''}`}
                name={props.attribute.name}
                value={attrValue}
                onKeyUp={props.keyPressSize}
                data-attrval={attrValue}
                data-attrid={attrValue}
                id={props.attribute.name + index}
                tabIndex='0'
                aria-pressed={`${props.selectedAttributeValue == attrValue ? 'true' : 'false'}`}
                aria-disabled={isAvailable(attrValue) || fromQuickView ? false : true}
                disabled={isAvailable(attrValue) || fromQuickView ? false : true}
              >
                {attrValue} {shouldShowPriceInButton && <PriceConvert priceOne={price} priceTwo={price} />}
              </button>
            );
          })}
        </div>

        {shouldShowAdditionalSize && (
          <div id='addtlSizesContainer'>
            <span>Also Available In:</span>
            {additionalSizes.map((currentSize) => {
              return (
                <Link
                  to={{
                    pathname: `/p/${currentSize.productURL}?addtlSizes=true`,
                    state: { qv: true, additionalSize: true, addSizeAttribute: currentSize.additionalName },
                  }}
                  className='additionalSizeLink'
                  key={currentSize.productId}
                  replace={
                    props.contentData.productLayout === 'QuickViewDisplay' ||
                    (props.isQuickview !== undefined && props.isQuickview === true)
                      ? true
                      : false
                  }
                >
                  {currentSize.additionalName}
                </Link>
              );
            })}
          </div>
        )}
      </div>
      <input type='hidden' value={props.attribute.name} name='attrName' />
    </>
  );
}
